class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.load();
  }

  async load() {
    const productId = this.dataset.productId;
    const limit = this.dataset.limit || 6;
    if (!productId) return;

    const track = this.querySelector('.cart-recommendations__track');
    if (!track) return;

    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      if (!res.ok) return;
      const data = await res.json();
const comboKeywords = ['duo', 'trio', 'kit'];
const products = (data.products || []).filter((product) => {
  const title = product.title.toLowerCase();
  return !comboKeywords.some((keyword) => title.includes(keyword));
});

if (!products.length) {
  this.style.display = 'none';
  return;
}

      track.innerHTML = products.map((product) => this.renderItem(product)).join('');

      track.querySelectorAll('[data-add-variant]').forEach((btn) => {
        btn.addEventListener('click', (e) => this.handleAdd(e));
      });

      this.setupArrows();
    } catch (err) {
      console.error('Erro ao buscar recomendações do carrinho:', err);
    }
  }

  renderItem(product) {
    const variant = product.variants && product.variants[0];
    const price = variant ? this.formatMoney(variant.price) : '';
    const image = product.featured_image || (product.images && product.images[0]) || '';

    return `
      <div class="cart-recommendations__item">
        <img class="cart-recommendations__image" src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
        <div class="cart-recommendations__info">
          <div class="cart-recommendations__name">${this.escapeHtml(product.title)}</div>
          <div class="cart-recommendations__price">${price}</div>
        </div>
        <button type="button" class="cart-recommendations__add" data-add-variant="${variant ? variant.id : ''}">Adicionar</button>
      </div>
    `;
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  async handleAdd(e) {
    const btn = e.currentTarget;
    const variantId = btn.dataset.addVariant;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      await this.refreshDrawer();

      btn.textContent = 'Adicionado!';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    } catch (err) {
      console.error('Erro ao adicionar produto recomendado:', err);
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }

 async refreshDrawer() {
  try {
    const res = await fetch(`${window.location.pathname}?sections=cart-drawer-section`);
    if (!res.ok) return;
    const data = await res.json();
    const html = data['cart-drawer-section'];
    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const { morph } = await import('@theme/morph');

    const newItems = doc.querySelector('.cart-drawer__items');
    const currentItems = document.querySelector('.cart-drawer__items');
    if (newItems && currentItems) {
      morph(currentItems, newItems, { childrenOnly: true });
    }

    const newSummary = doc.querySelector('.cart-drawer__summary');
    const currentSummary = document.querySelector('.cart-drawer__summary');
    if (newSummary && currentSummary) {
      morph(currentSummary, newSummary, { childrenOnly: true });
    }

    const newBadge = doc.querySelector('.theme-drawer__badge');
    const currentBadge = document.querySelector('.theme-drawer__badge');
    if (newBadge && currentBadge) {
      currentBadge.textContent = newBadge.textContent;
    }

    // Recarrega manualmente as recomendações, já que o morph zera o carrossel
    const recommendationsEl = document.querySelector('cart-recommendations');
    if (recommendationsEl) {
      recommendationsEl.dataset.initialized = 'false';
      recommendationsEl.load();
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (err) {
    console.error('Erro ao atualizar o drawer do carrinho:', err);
  }
}

  setupArrows() {
    const track = this.querySelector('.cart-recommendations__track');
    const prev = this.querySelector('.cart-recommendations__arrow--prev');
    const next = this.querySelector('.cart-recommendations__arrow--next');
    if (!track || !prev || !next) return;

    prev.addEventListener('click', () => track.scrollBy({ left: -240, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: 240, behavior: 'smooth' }));
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}